/* @ngInject */
export function uahDateFilter ($filter) {
	return function (date) {
		if (!date) {
			return 'N/A';
		}
		return $filter('date')(date, 'MMM d, y') + ' at ' + $filter('date')(date, 'h:mm a');
	};
}
